import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useId, } from 'react';
import { Icon } from './Icon';
import { cx } from './cx';
/** Label, Feld, Hilfe oder Fehler — Hilfe und Fehler hängen per aria-describedby am Feld. */
export function Field({ label, required, help, error, children }) {
    const id = useId();
    const hinweisId = help || error ? `${id}-hinweis` : undefined;
    return (_jsxs("div", { className: "one-field", children: [_jsxs("label", { className: "one-label", htmlFor: id, children: [label, required && ' ·'] }), children(id, hinweisId), error ? (_jsxs("span", { className: "one-error", id: hinweisId, children: [_jsx(Icon, { name: "circle-alert", size: "sm" }), error] })) : (help && (_jsx("span", { className: "one-help", id: hinweisId, children: help })))] }));
}
export const Input = forwardRef(function Input({ invalid, className, ...rest }, ref) {
    return (_jsx("input", { ref: ref, className: cx('one-input', className), "aria-invalid": invalid ? 'true' : undefined, ...rest }));
});
export const Textarea = forwardRef(function Textarea({ invalid, className, rows = 4, ...rest }, ref) {
    return (_jsx("textarea", { ref: ref, rows: rows, className: cx('one-input', 'one-textarea', className), "aria-invalid": invalid ? 'true' : undefined, ...rest }));
});
export const Select = forwardRef(function Select({ className, ...rest }, ref) {
    return _jsx("select", { ref: ref, className: cx('one-select', className), ...rest });
});
/** Freitextsuche im Inhalt (nicht die globale Suche — die gehört der Shell). */
export function SearchInput({ label, className, ...rest }) {
    return (_jsxs("div", { className: cx('one-input-group', className), children: [_jsx(Icon, { name: "search" }), _jsx("input", { type: "search", className: "one-input", "aria-label": label, ...rest })] }));
}
export function Checkbox({ label, indeterminate, className, ...rest }) {
    const box = (_jsx("input", { type: "checkbox", className: cx('one-checkbox', className), ref: (el) => {
            if (el)
                el.indeterminate = Boolean(indeterminate);
        }, ...rest }));
    if (!label)
        return box;
    return (_jsxs("label", { className: "one-check-row", children: [box, _jsx("span", { children: label })] }));
}
/** Schalter für sofort wirksame Einstellungen; für Formulare ist die Checkbox richtig. */
export function Toggle({ checked, onChange, label, disabled, hideLabel }) {
    const id = useId();
    return (_jsxs("span", { className: "one-check-row", children: [_jsx("button", { id: id, type: "button", role: "switch", "aria-checked": checked, className: "one-toggle", disabled: disabled, onClick: () => onChange(!checked) }), _jsx("label", { htmlFor: id, className: hideLabel ? 'one-sr' : undefined, children: label })] }));
}
